// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import 'animate.css'
import 'vant/lib/index.css'
import './assets/css/common.css'
import { Toast, Uploader, DatetimePicker } from 'vant'
import '@vant/touch-emulator'
import SignCanvas from 'sign-canvas'
import html2canvas from 'html2canvas'
import i18n from './configs/language'

Vue.use(SignCanvas)
Vue.use(html2canvas)
Vue.use(Toast, DatetimePicker)
Vue.use(Uploader)

// 接口数据缓存
const cache = {}
const EXPIRE_TIME = 600000
// const TOKEN_EXPIRE_TIME = 60; // 前端存储 Cookie 的有效时间
const authorizeTypeMap = {
  // 授权持久化登录
  37: 2, // 37-AND
  41: 2, // 41-新AND
  1001: 3 // gemgala
}

// 非登录状态，路由拦截
const noAuthorizationPage = [
  '/login',
  '/register',
  '/countries',
  '/account/authorize',
  '/before-login',
  '/account/quickLogin/authorize',
  '/check-user-info' // 单独处理登录态
]

// 接口白名单，不对数据进行处理
const apiWhiteList = [
  '/api/file/upload', // FormData数据
  'logapi.ichamet.com/report/log' // 大数据埋点，不参与通用参数处理
]

let requestErrorList = []
let isRefreshToken = false // 是否刷新Token
const CancelToken = axios.CancelToken
// 请求拦截器
axios.interceptors.request.use((config) => {
  // 检查是否是白名单接口
  let isInApiWhiteList = false
  apiWhiteList.forEach((item) => {
    if (config.url.includes(item)) {
      isInApiWhiteList = true
    }
  })
  // 不在白名单中，则对请求参数进行处理
  if (!isInApiWhiteList) {
    // 追加语言配置
    let lang = localStorage.getItem('language')
    if (config.method === 'get') {
      if (config.url.indexOf('?') > -1) {
        config.url += `&language=${lang}`
      } else {
        config.url += `?language=${lang}`
      }
    } else if (config.method === 'post') {
      if (typeof config.data === 'string') {
        config.data = {
          ...JSON.parse(config.data || '{}'),
          language: lang
        }
      } else {
        config.data = {
          ...config.data,
          language: lang
        }
      }
    }

    // 走授权登录，则在请求中增加 ctype，以此增加 token 的有效期
    let apptype = localStorage.getItem('apptype')
    if (apptype && apptype.includes(',')) {
      localStorage.setItem('apptype', apptype.split(',')[0])
      apptype = apptype.split(',')[0]
    }
    if (apptype && Object.keys(authorizeTypeMap).includes(apptype)) {
      if (config.method === 'get') {
        // 如果 url 中有参数，则追加，否则追加?
        if (config.url.indexOf('?') > -1) {
          config.url += '&cType=' + authorizeTypeMap[apptype]
        } else {
          config.url += '?cType=' + authorizeTypeMap[apptype]
        }
      } else if (config.method === 'post') {
        if (typeof config.data === 'string') {
          config.data = {
            ...JSON.parse(config.data || '{}'),
            cType: authorizeTypeMap[apptype]
          }
        } else {
          config.data = {
            ...config.data,
            cType: authorizeTypeMap[apptype]
          }
        }
      }
    }
  }

  // 专门针对获取国家列表的接口，走缓存，避免重复多次请求浪费时间
  if (config.cache) {
    const source = CancelToken.source()
    config.cancelToken = source.token
    // 取出缓存的数据
    const data = cache[config.url]
    const expireTime = getExpireTime()
    // 判断缓存的数据是否存在且是否过期
    if (data && expireTime - data.expire < (config.expire || EXPIRE_TIME)) {
      // 数据未过期则取消当前的请求并直接返回到response拦截器的error中
      source.cancel(data)
    }
  }

  // build 模式下不在请求中携带cookies
  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'testing') {
    // config.withCredentials = true;
  }
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.common['token'] = token
  }
  return config
})

// 快捷登录
function quickLogin(appCode, walletCode) {
  return instance.post(window.serverPath + '/api/auth/checkQuickLoginCode', {
    appCode: appCode,
    walletCode: walletCode
  })
}

const instance = axios.create({
  baseURL: '',
  timeout: 300000
})

instance.setToken = (token) => {
  instance.defaults.headers['Token'] = token
  window.localStorage.setItem('token', token)
}

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code === '401') {
      // 根据appCode和walletCode判断是否免登录，是的话，尝试通过免登录刷新 token
      const urlParams = new URLSearchParams(window.location.search)
      const appCode = urlParams.get('appCode')
      const walletCode = urlParams.get('walletCode')
      const config = response.config
      // 如果 appCode 和 walletCode 都存在，则尝试通过免登录刷新token
      if (appCode && walletCode) {
        if (!isRefreshToken) {
          isRefreshToken = true
          quickLogin(appCode, walletCode)
            .then((res) => {
              if (res.data.code === '200') {
                localStorage.setItem('token', res.data.data)
                requestErrorList.forEach((func) => func(res.data.data))
                requestErrorList = []
                config.headers['token'] = res.data.data
                // 重新执行被拦截的请求
                return instance(config)
              } else {
                const len = history.length
                history.go(-len) // Return at the beginning
                localStorage.removeItem('token')
                localStorage.removeItem('store')
                window.location.replace(process.env.ROUTER_BASE + 'before-login')
              }
            })
            .catch((res) => {
              const len = history.length
              history.go(-len) // Return at the beginning
              localStorage.removeItem('token')
              localStorage.removeItem('store')
              window.location.replace(process.env.ROUTER_BASE + 'before-login')
            })
            .finally(() => {
              isRefreshToken = false
            })
        } else {
          // 正在刷新token，将返回一个未执行resolve的promise
          return new Promise((resolve) => {
            // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
            requestErrorList.push((token) => {
              localStorage.setItem('token', token)
              config.headers['token'] = token
              resolve(instance(config)) // 重新执行被拦截的请求
            })
          })
        }
      } else {
        console.log('当前请求未授权，即将跳转到登录页')
        // 当前页是收银台则记录重定向信息
        if (window.location.pathname === '/recharge') {
          sessionStorage.setItem('redirectInfo', window.location.pathname + window.location.search)
        } else if (window.location.pathname === '/account/authorize') {
          sessionStorage.setItem('redirectInfo', window.location.pathname + window.location.search)
        }
        const len = history.length
        history.go(-len) // Return at the beginning
        localStorage.removeItem('token')
        localStorage.removeItem('store')
        window.location.replace(process.env.ROUTER_BASE + 'before-login')
      }
    } else if (response.config.cache && response.config.method === 'get') {
      // 将当前时间和待缓存的数据存入cache中
      cache[`${response.config.url}`] = {
        expire: getExpireTime(),
        data: response.data
      }
    }
    return response
  },
  (error) => {
    // 判断是否有数据返回，有缓存的数据则直接返回
    if (axios.isCancel(error)) {
      return Promise.resolve(error.message)
    }
    return Promise.reject(error)
  }
)

function getExpireTime() {
  return new Date().getTime()
}
// 重置根节点 font-size，方便实现rem布局
function setHTMLFontSize() {
  let docEl = document.documentElement
  let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
  let recalc = function () {
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    docEl.style.fontSize = 100 * (Math.min(clientWidth, 640) / 375) + 'px'
  }

  if (!document.addEventListener) return
  window.addEventListener(resizeEvt, recalc, false)
  document.addEventListener('DOMContentLoaded', recalc, false)
  if (localStorage.getItem('isWebView')) {
    document.getElementsByTagName('body')[0].style.height = '100vh'
  } else {
    document.getElementsByTagName('body')[0].style.height = window.innerHeight + 'px'
  }
}
Vue.config.productionTip = false
Vue.prototype.$http = axios
window.serverPath = process.env.SERVER_PATH

// eslint-disable-next-line no-unused-vars
const vue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>',
  created: function () {
    if (this.$route.query.email || this.$route.query.phone) {
      sessionStorage.setItem(
        'acctData',
        JSON.stringify({
          phone: this.$route.query.phone,
          email: this.$route.query.email,
          areaCode: this.$route.query.areaCode
        })
      )
    }
    let loginToken = localStorage.getItem('token')
    let store = localStorage.getItem('store')
    let isQuickLoginUser = this.$route.query.appCode && this.$route.query.walletCode
    // apptype没有则做本地记录
    let apptype = localStorage.getItem('apptype')
    if (apptype && apptype.includes(',')) {
      localStorage.setItem('apptype', apptype.split(',')[0])
      apptype = apptype.split(',')[0]
    }
    // 针对 apptype 不是 number 的情况做下特殊处理，处理脏数据
    if ((this.$route.query.apptype && !apptype) || (this.$route.query.apptype && !Number(apptype))) {
      apptype = this.$route.query.apptype instanceof Array ? this.$route.query.apptype[0] : this.$route.query.apptype
      localStorage.setItem('apptype', apptype)
    }

    // 登录且本地存在 store，跟新当前 store 并持久化处理
    if (loginToken && store) {
      this.$store.replaceState(
        Object.assign({}, this.$store.state, {
          ...JSON.parse(store)
        })
      )
    }

    // 记录APP传递的状态栏高度参数
    const statusBarHeight = this.$route.query.statusBarHeight
    if (statusBarHeight && Number(statusBarHeight) >= 0) {
      localStorage.setItem('isWebView', '1')
      this.$store.commit('setStatusBarHeight', statusBarHeight)
    }

    // 页面刷新前将vuex里的信息保存到localStorage
    // Note: 此处的事件在Android WebView会出现触发不了的情况
    const eventName =
      navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) ? 'pagehide' : 'beforeunload'
    window.addEventListener(eventName, () => {
      localStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    // 走授权登录持久化逻辑,判断是否存在本地登录态，是则正常访问并获取用户信息，否则跳转到登录页
    if (loginToken) {
      this.$http
        .get(window.serverPath + '/api/user/info')
        .then((res) => {
          if (res.data.code === '200') {
            this.$store.commit('setUserInfo', res.data.data)
            localStorage.setItem('store', JSON.stringify(this.$store.state))
            sessionStorage.removeItem('acctData')
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    } else if (isQuickLoginUser && noAuthorizationPage.indexOf(this.$route.path) === -1) {
      // 没有本地登录态但是携带有免登录标识，并且访问的不是白名单页面，则进行免登录校验
      // this.$http
      //   .post(window.serverPath + "/api/auth/checkQuickLoginCode", {
      //     appCode: this.$route.query.appCode,
      //     walletCode: this.$route.query.walletCode
      //   })
      //   .then(async (res) => {
      //     if (res.data.code === "200") {
      //       localStorage.setItem("token", res.data.data)
      //       await this.getUserInfo(res.data.data)
      //     } else {
      //       // 校验失败，跳转到登录页面
      //       const len = history.length
      //       history.go(-len)
      //       this.$router.replace({ name: "beforeLogin" }).then(() => {
      //         // 清空用户基本信息
      //         this.$store.commit("delUserInfo")
      //         this.$store.commit("setBalance", 0)
      //       })
      //     }
      //   })
    } else if (noAuthorizationPage.indexOf(this.$route.path) === -1) {
      // 非登录状态，且访问的页面不是白名单页面，重定向到登录页面
      // 当前页是收银台则记录重定向信息
      if (window.location.pathname === '/recharge') {
        sessionStorage.setItem('redirectInfo', window.location.pathname + window.location.search)
      }
      const len = history.length
      history.go(-len)
      this.$router.replace({ name: 'beforeLogin' }).then(() => {
        // 清空用户基本信息
        this.$store.commit('delUserInfo')
        this.$store.commit('setBalance', 0)
      })
    }
    setHTMLFontSize()
  }
})



// WEBPACK FOOTER //
// ./src/main.js